function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stLBG0{fill:#3F9C35;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "stLBG0",
  d: "M478.3,326.8l1.7,135.1c0,15.9-10.9,30.8-26.6,33.4c-20,3.3-37.4-12.1-37.4-31.6v-48c0-44.2-35.8-80-80-80h-16 v-192c0-35.3-28.7-64-64-64H96c-35.3,0-64,28.7-64,64v416H8c-4.4,0-8,3.6-8,8v16c0,4.4,3.6,8,8,8h336c4.4,0,8-3.6,8-8v-16 c0-4.4-3.6-8-8-8h-24v-192h16c26.5,0,48,21.5,48,48v44.4c0,31.9,21.7,61.5,53.2,66.7c40.1,6.6,74.8-24.3,74.8-63.1l-2-128.2  M288,559.7H64v-256h224V559.7z M288,271.7H64v-128c0-17.6,14.4-32,32-32h160c17.6,0,32,14.4,32,32V271.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "stLBG0",
  d: "M602.2,3.6c-5.7-4.1-12.9-0.2-12.8,6.7c0.1,31.7-15.9,60.8-43.9,77l-35.3,20.4c-46.8,27.1-62.9,87-35.8,133.9 c1.8,3.1,3.9,5.8,5.9,8.7c16.5-36.5,47.3-77.2,105-110.5c3.9-2.2,8.9-0.9,11.2,3s0.9,8.9-3,11.2C482.4,218.1,474.7,313.4,479.1,345 c1.2,8.9,9.4,15.1,18.4,13.9c9-1.2,12.1-8.6,12.9-18.1c-0.3-2-1.9-26.7,9.7-58.6c25.5,11.1,63.5,13.9,97-10.6 c66.5-45.1,79.3-135.6,35.3-211.8C639.5,37.7,621.5,17.4,602.2,3.6z"
});

const SvgIconLbg = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 679 591.7",
    style: {
      enableBackground: "new 0 0 679 591.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLbg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-LBG.8491ae2f.svg";
export { ForwardRef as ReactComponent };